const settings = {
    // baseUrl: "https://localhost:7200",
    baseUrl: "https://nostalgic-shaw.68-178-200-190.plesk.page",
}

export default settings;